import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { NavigationComponent } from "../types";
import { useRouteMatch } from "react-router-dom";

interface SubNavBarProps
{
    appSetup: NavigationComponent[];
    landingPage: string;
    studentId: string;
}

const SubNavBar = ({ appSetup, landingPage, studentId }: SubNavBarProps): React.ReactElement => 
{
    return <Navbar aria-label="Sub Navigation Bar" className={"subnav"} bg={"dark"} expand="sm">
        <Navbar.Toggle aria-label="Sub Navigation Bar" aria-controls="sub-navbar-nav" />
        <Navbar.Collapse id={"sub-navbar-nav"} >
            <Nav activeKey={"/"}>
                {appSetup.map(link => 
                {
                    const match = useRouteMatch({
                        path: `/${link.id}`,
                        exact: false
                    });

                    if (studentId)
                    {
                        studentId = studentId.replace("/", "");
                        studentId = "/" + studentId;
                    }

                    let isMatch = match ? true : false;

                    if (link.id == landingPage && window.location.hash.substr(1) == "/")
                        isMatch = true;

                    return <React.Fragment key={link.id}>
                        <Nav.Link key={link.id} {...(isMatch ? { "aria-current": "page" } : {})} href={"#" + link.id + studentId} active={isMatch}>{link.title}</Nav.Link>
                    </React.Fragment>;
                })}
            </Nav>
        </Navbar.Collapse>
    </Navbar>;
};

export default SubNavBar;